import _isError from "lodash/isError";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.index-of.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import "./index.scss";
import { assert } from "@/common/assert";
import { simpleAlert, functionAlert } from "@/pages/modules/alerts";
import { basicAccountInfoManager } from "@/pages/base/basicAccountInfoManager";
import { createLiveQuery } from "@/pages/vendors/vendor.livequery";
import { debounce } from "@/pages/base/asyncUtils";
import jqueryDataUtil from "@/common/jqueryDataUtil";
import { FollowApiApi } from "@/apis/api/FollowApiApi";
$(function () {
  var getUserId = function getUserId($el) {
    return jqueryDataUtil.optionalNumber($el, "userid");
  };

  var getCompanyId = function getCompanyId($el) {
    return jqueryDataUtil.optionalNumber($el, "companyid");
  };

  $(".js-follow").each(function () {
    var $this = $(this);
    var userid = getUserId($this);
    var companyId = getCompanyId($this);
    assert(userid || companyId, "Either data-userid or data-companyid must be defined for .js-follow");
  });

  function syncFollowStatus() {
    return __awaiter(this, void 0, void 0, function () {
      var $jsFollows, userIds, companyIds, areFollowed_1, areFollowed_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            $jsFollows = $(".js-follow").filter(function (_idx, el) {
              return !$(el).hasClass("js-follow--synced");
            });
            userIds = [];
            companyIds = [];
            $jsFollows.each(function (_, el) {
              var $el = $(el);
              var userId = getUserId($el);
              var companyId = getCompanyId($el);
              assert(!(userId && companyId), "userId && companyId cannot be both truthy");

              if (userId) {
                userIds.push(userId);
              } else if (companyId) {
                companyIds.push(companyId);
              }
            });
            if (!userIds.length) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , new FollowApiApi().followApiGetFolloweeIdsAsync({
              model: {
                Ids: userIds
              }
            })];

          case 1:
            areFollowed_1 = _a.sent();
            $jsFollows.each(function () {
              var $this = $(this);
              var $objFollowText = $this.find(".follow__text").length > 0 ? $this.find(".follow__text") : $this;
              var userId = getUserId($this);

              if (userId) {
                $this.addClass("js-follow--synced");
                var isFollowed = areFollowed_1.indexOf(userId) > -1;

                if (isFollowed) {
                  $this.addClass("follow--active");
                  $this.addClass("follow--active-btn");
                  $objFollowText.text("已关注");
                } else {
                  $objFollowText.text("关注");
                  $this.removeClass("follow--active");
                  $this.removeClass("follow--active-btn");
                }
              }
            });
            _a.label = 2;

          case 2:
            if (!companyIds.length) return [3
            /*break*/
            , 4];
            return [4
            /*yield*/
            , new FollowApiApi().followApiGetFollowCompanyIdsAsync({
              model: {
                Ids: companyIds
              }
            })];

          case 3:
            areFollowed_2 = _a.sent();
            if (!areFollowed_2) return [2
            /*return*/
            ];
            $jsFollows.each(function () {
              var $this = $(this);
              var companyId = getCompanyId($this);

              if (companyId) {
                $this.addClass("js-follow--synced");
                var isFollowed = areFollowed_2.indexOf(companyId) > -1;

                if (isFollowed) {
                  $this.addClass("follow--active");
                  $this.addClass("follow--active-btn");
                  $this.text("已关注");
                } else {
                  $this.text("关注商铺");
                  $this.removeClass("follow--active");
                  $this.remove("follow--active-btn");
                }
              }
            });
            _a.label = 4;

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  }

  basicAccountInfoManager.getBasicAccountInfo().then(function (info) {
    if (!info.UserId) return;
    $(".js-follow").each(function () {
      $(this).data("loginuserid", info.UserId);
    });
    syncFollowStatus();
    createLiveQuery($(".js-follow"), debounce(100, syncFollowStatus));
  });
  $(document).on("click", ".js-follow", function () {
    return __awaiter(this, void 0, void 0, function () {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      function handleError(err) {
        simpleAlert("操作失败！");

        if (userid_1) {
          $objFollowText_1.text(isFollowed_1 ? "关注" : "已关注");
        } else {
          $this_1.text(isFollowed_1 ? "关注商铺" : "已关注");
        }

        $this_1.toggleClass("follow--active", !isFollowed_1);
        $this_1.toggleClass("follow--active-btn", !isFollowed_1);
        console.error(err);
      }

      var res, $this_1, isFollowed_1, $objFollowText_1, userid_1, companyId, loginuserid;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , basicAccountInfoManager.proceedAfterLogin()];

          case 1:
            res = _a.sent();

            if (!_isError(res)) {
              $this_1 = $(this);
              isFollowed_1 = $this_1.is(".follow--active") || $this_1.is(".follow--active-btn");
              $objFollowText_1 = $this_1.find(".follow__text").length > 0 ? $this_1.find(".follow__text") : $this_1;
              userid_1 = getUserId($this_1);
              companyId = getCompanyId($this_1);
              $this_1.toggleClass("follow--active", isFollowed_1);
              $this_1.toggleClass("follow--active-btn", isFollowed_1);

              if (userid_1) {
                if (isFollowed_1) {
                  new FollowApiApi().followApiUserUnFollowAsync({
                    followeeId: userid_1
                  })["catch"](handleError);
                } else {
                  loginuserid = jqueryDataUtil.optionalNumber($this_1, "loginuserid");

                  if (loginuserid && loginuserid == userid_1) {
                    functionAlert("自己不能关注自己!", function () {});
                    return [2
                    /*return*/
                    ];
                  }

                  new FollowApiApi().followApiUserFollowAsync({
                    followeeId: userid_1
                  })["catch"](handleError);
                }

                $objFollowText_1.text(isFollowed_1 ? "关注" : "已关注");
              } else if (companyId) {
                if (isFollowed_1) {
                  new FollowApiApi().followApiCompanyUnFollowAsync({
                    companyId: companyId
                  })["catch"](handleError);
                } else {
                  new FollowApiApi().followApiCompanyFollowAsync({
                    companyId: companyId
                  })["catch"](handleError);
                }

                $objFollowText_1.text(isFollowed_1 ? "关注商铺" : "已关注");
              }

              $this_1.toggleClass("follow--active", !isFollowed_1);
              $this_1.toggleClass("follow--active-btn", !isFollowed_1); // $this.find(".icon").toggleClass("post-operation__collect-icon", !isCollected);
            } else {
              simpleAlert(res.message);
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  });
});